export const DATE_RANGE_KEY = 'insightsDateRange';
export const INSIGHTS_LOCATIONS_KEY = 'insightsLocations';
